/*
<summary>
   This file is used to provide initial values or state to the AddProcessForm.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import { IGetNonConformance } from '../../models/response/IAddedNonConformanceResponse';
const initialProcessState: IGetNonConformance = {
  Id: 0,
  TrayId: '',
  Tray: 0,
  DetectionProcessId: 0,
  DetectionProcessName: '',
  ReturnProcessId: -1,
  ReturnProcessName: '',
  DetectedBy: 0,
  DetectedByName: '',
  DetectedOn: '',
  WorkingDays: '',
  Katashiki: '',
  Kishu: '',
  worker: '',
  SubContractor: 0,
  SubContractorName: '',
  Status: 0,
  NCApprovedBy: 0,
  NCApprovedByName: '',
  NCApprovedOn: '',
  WorkApprovedBy: 0,
  WorkApprovedByName: '',
  WorkApprovedOn: '',
  CorrectionTime: 0,
  NonConformanceItems: [],
  NCNGDetailModelItems: [],
  ProductId: '',
  Quantity: 0,
};

export const getInitialNonConformityState = (): IGetNonConformance => ({
  Id: 0,
  TrayId: '',
  Tray: 0,
  DetectionProcessId: 0,
  DetectionProcessName: '',
  ReturnProcessId: -1,
  ReturnProcessName: '',
  DetectedBy: 0,
  DetectedByName: '',
  DetectedOn: '',
  WorkingDays: '',
  Katashiki: '',
  Kishu: '',
  worker: '',
  SubContractor: 0,
  SubContractorName: '',
  Status: 0,
  NCApprovedBy: 0,
  NCApprovedByName: '',
  NCApprovedOn: '',
  WorkApprovedBy: 0,
  WorkApprovedByName: '',
  WorkApprovedOn: '',
  CorrectionTime: 0,
  NonConformanceItems: [],
  NCNGDetailModelItems: [],
  ProductId: '',
  Quantity: 0,
});

export default initialProcessState;
